export default {
  isLogin ({ loginStatus }) {
    return !!loginStatus;
  },
  userInfo ({ userInfo }) {
    return userInfo;
  },
  mchDetail ({ mchDetail }) {
    return mchDetail;
  },
  privileges ({ userInfo }) {
    return userInfo.privileges;
  },
  register_key ({ register_key }) {
    return register_key;
  },
  downList ({ downList }) {
    return downList;
  },
  browser ({ browser }) {
    return browser;
  },
};
